import { render, staticRenderFns } from "./ResetPasswd.vue?vue&type=template&id=4619e09b&"
import script from "./ResetPasswd.vue?vue&type=script&lang=js&"
export * from "./ResetPasswd.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswd.vue?vue&type=style&index=0&id=4619e09b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports